export default __webpack_public_path__ + "static/media/placeholder_text.29f367f1.svg";